export default __webpack_public_path__ + "static/media/paymentIcon.51fdd10c.svg";